import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import * as release from '@webapp/sdk/release';
import { Action } from 'redux';
import { ListReleases, ListReleasesSuccess, ListReleasesError } from '../action-creators';
import { LIST_RELEASES } from '../actions';
import AppState from '../../state';


export const listReleasesEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, ListReleases>(LIST_RELEASES),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.artist.active),
    mergeMap(async ([action, state]) => {
      try {
        const status = action.status === 'all' ? undefined : action.status;
        const releases = await release.list(state.artist.active?.id as string, status);

        return new ListReleasesSuccess(releases, action.status, action.includeTracks);
      } catch (err) {
        return new ListReleasesError(err.message)
      }
    })
  );